import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import { HttpResponse } from "@angular/common/http";

import {EstudioService} from "../estudio.service";


@Injectable({
  providedIn: 'root'
})
export class NivelacionesResolver  {

    constructor(private router: Router, private estudioService: EstudioService) {
    }

    resolve(routeSnap: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HttpResponse<any>> {
        let id = routeSnap.paramMap.get('id'),
            idMes = routeSnap.paramMap.get('idMes');
        return this.estudioService.getNivelacionesMCP(id, idMes)/*.map(nivelaciones => {
            return nivelaciones;
        })*/;
    }
}
